import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";
import BlogNavbar from "./blogNavbar";

function Blog() {
  return (
    <>
      {/* NAVBAR DO BLOG */}
      <BlogNavbar />

      {/* CONTEÚDO DO BLOG */}
      <section className="blog-section">
        <div className="container">

          {/* CABEÇALHO */}
          <div className="blog-header">
            <h1>Blog – Engenharia Civil</h1>
            <p>
              Artigos técnicos, orientações acadêmicas e conteúdos essenciais
              para estudantes e profissionais de Engenharia Civil.
            </p>
          </div>

          {/* GRID PRINCIPAL */}
          <div className="blog-grid">

            {/* DESTAQUE PRINCIPAL */}
            <article className="blog-featured">
              <img src="/Images/blog-concreto.jpg" alt="Controle tecnológico do concreto" />
              <div className="featured-content">
                <span className="blog-tag">DESTAQUE</span>
                <h2>Controle Tecnológico do Concreto: Guia Completo</h2>
                <p>
                  Entenda como o controle tecnológico garante segurança,
                  durabilidade e conformidade normativa em estruturas de concreto.
                </p>

                <Link to="/blog/controle-tecnologico-do-concreto">
                  Ler artigo completo
                </Link>
              </div>
            </article>

            {/* COLUNA LATERAL */}
            <div className="blog-side">

              <article className="blog-small">
                <img src="/Images/blog-abnt.jpg" alt="Normas ABNT" />
                <div>
                  <span className="blog-tag">ABNT</span>
                  <h3>Normas ABNT no TCC de Engenharia Civil</h3>
                  <Link to="/blog/normas-abnt-tcc-engenharia-civil">
                    Ler artigo
                  </Link>
                </div>
              </article>

              <article className="blog-small">
                <img src="/Images/blog-estrutura.jpg" alt="Cálculo estrutural" />
                <div>
                  <span className="blog-tag">Estruturas</span>
                  <h3>Erros comuns em Cálculos Estruturais</h3>
                  <Link to="/blog/erros-calculos-estruturais">
                    Ler artigo
                  </Link>
                </div>
              </article>

              <article className="blog-small">
                <img src="/Images/blog-metodologia.jpg" alt="Metodologia científica" />
                <div>
                  <span className="blog-tag">Metodologia</span>
                  <h3>Metodologia Científica no TCC</h3>
                  <Link to="/blog/metodologia-cientifica-tcc">
                    Ler artigo
                  </Link>
                </div>
              </article>

            </div>

          </div>

          {/* LISTA INFERIOR */}
          <div className="blog-list">

            <article>
              <span className="blog-tag">Fundações</span>
              <h4>Noções básicas sobre Fundações</h4>
              <p>
                Tipos de fundações, critérios de escolha e erros comuns em
                projetos acadêmicos e profissionais.
              </p>
            </article>

            <article>
              <span className="blog-tag">Materiais</span>
              <h4>Ensaios laboratoriais mais usados na Engenharia Civil</h4>
              <p>
                Conheça os principais ensaios exigidos em normas técnicas.
              </p>
            </article>

            <article>
              <span className="blog-tag">Projeto</span>
              <h4>Como estruturar um bom memorial descritivo</h4>
              <p>
                Orientações práticas para elaboração de memoriais técnicos.
              </p>
            </article>

          </div>

        </div>
      </section>
    </>
  );
}

export default Blog;
